<template>
    <div class="download">
        <div class="pc" v-if="equipment == 'pc'">
            <navig :w="w" :only="only" :mask="mask" />
            <img src="~img/Thecore/06.png" class="top_img" />
            <main>
                <ul class="naviga">
                    <li class="active">
                        <span>{{ title }}</span>
                        <div v-if="title.trim()" class="active"></div>
                    </li>
                </ul>
                <div class="remark">
                    <p v-html="remark"></p>
                </div>
                <div ref="tableArea" class="resource-table-area">
                    <table v-if="columns.length" ref="resourceTable" class="resource-table" :style="tableStyle">
                        <colgroup>
                            <col v-for="(column, index) in columns" :key="column.key"
                                :style="columnStyle(index)" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th v-for="column in columns" :key="column.key" scope="col">
                                    <div class="cell-content">{{ column.title }}</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, rowIndex) in tableData" :key="rowIndex">
                                <td v-for="column in columns" :key="column.key">
                                    <div class="cell-content">
                                        <template v-if="column.type === 'text'">
                                            <div class="text-call" v-for="(text, index) in row[column.key]"
                                                :key="index">
                                                {{ text.value }}
                                            </div>
                                        </template>
                                        <template v-else-if="column.type === 'link'">
                                            <div class="link-call" v-for="(link, index) in row[column.key]"
                                                :key="index">
                                                <a :href="formatUrl(link.value)" target="_blank"
                                                    rel="noopener noreferrer">
                                                    <span v-if="link.key">{{ link.key }}</span>
                                                    <span v-else>{{ link.value }}</span>
                                                </a>
                                            </div>
                                        </template>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </main>
            <pc-footer :showFooter="showFooter" />
        </div>



        <div class="web" v-if="equipment == 'web'">
            <webNav v-if="equipment == 'web'" :mask="mask" />
            <div class="top_box"></div>
            <img src="~img/Thecore/12.png" class="top_img" />
            <main>
                <div class="web-title">{{ title }}</div>
                <div v-if="title.trim()" class="heng"></div>
                <div class="Introduction" v-html="remark"></div>
                <div class="table-web">
                    <ul v-for="(item, rowIndex) in webTable" :key="rowIndex">
                        <li v-for="val in item" :key="val.key">
                            <div class="label-text">{{ val.label }}</div>
                            <div class="label-value" v-if="val.type === 'text'">
                                <div v-for="(text, index) in val.value" :key="index">{{ text.value }}</div>
                            </div>
                            <div class="label-links" v-if="val.type === 'link'">
                                <a :href="formatUrl(links.value)" class="label-link"
                                    v-for="(links, index) in val.value" :key="index">
                                    <span v-if="links.key">{{ links.key }}</span>
                                    <span v-else>{{ links.value }}</span>
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </main>
            <up />
            <div class="foot">
                <web-footer />
            </div>
        </div>
    </div>
</template>


<script>
import navig from "@/components/navigation.vue"; // pc 导航
import pcFooter from "@/components/pcFooter.vue"; // pc 底部
import webNav from "@/components/webNav.vue"; // web 导航
import webFooter from "@/assembly/web/webFooter.vue"; // web 底部
import up from "@/components/Backtotop.vue";
import { allocateColumnWidths, measureColumns } from "./resourceTableLayout";

function isRecord(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value)
}

function parseArray(value) {
    if (Array.isArray(value)) return value
    if (typeof value !== 'string') return []
    try {
        const parsed = JSON.parse(value)
        return Array.isArray(parsed) ? parsed : []
    } catch (e) {
        return []
    }
}

function asText(value) {
    return value == null ? '' : String(value)
}

export default {
    components: {
        navig,
        pcFooter,
        webNav,
        webFooter,
        up,
    },
    data() {
        return {
            w: undefined,
            equipment: "",
            only: true,
            mask: "NO",
            showFooter: true,
            columns: [],
            tableData: [],
            infoId: '',
            title: '',
            remark: '',
            columnMetrics: [],
            columnWidths: [],
            tableWidth: 0,
            tableResizeObserver: null,
            layoutFrame: null,
            layoutNeedsMeasurement: false,
            layoutDisposed: false,
            detailRequestId: 0,
        };
    },
    created() {
        this.w = document.documentElement.clientWidth || document.body.clientWidth;
        if (this.w <= 750) {
            this.equipment = "web";
        } else {
            this.equipment = "pc";
        }
        this.infoId = asText(this.$route.query.infoId);
        this.getDetail();
    },
    mounted() {
        window.addEventListener('resize', this.handleViewportResize)
        this.$nextTick(() => {
            this.bindTableResizeObserver()
            this.scheduleTableLayout(true)
        })

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => this.scheduleTableLayout(true))
        }
    },
    beforeDestroy() {
        this.layoutDisposed = true
        this.detailRequestId += 1
        window.removeEventListener('resize', this.handleViewportResize)
        this.disconnectTableResizeObserver()
        if (this.layoutFrame !== null) {
            cancelAnimationFrame(this.layoutFrame)
            this.layoutFrame = null
        }
    },
    watch: {
        '$route.query.infoId'(value) {
            this.infoId = asText(value)
            this.getDetail()
        },
        columns: {
            deep: true,
            handler: 'scheduleDataLayout',
        },
        tableData: {
            deep: true,
            handler: 'scheduleDataLayout',
        },
        equipment(value) {
            if (value === 'pc') {
                this.$nextTick(() => {
                    this.bindTableResizeObserver()
                    this.scheduleTableLayout(true)
                })
            } else {
                this.disconnectTableResizeObserver()
            }
        }
    },
    computed: {
        webTable() {
            return this.tableData.map(row => this.columns.map(column => ({
                key: column.key,
                label: column.title,
                value: row[column.key] || [],
                type: column.type,
            })))
        },
        tableStyle() {
            return {
                width: this.tableWidth ? `${this.tableWidth}px` : '100%'
            }
        }
    },
    methods: {
        handleViewportResize() {
            this.w = document.documentElement.clientWidth || document.body.clientWidth
            this.equipment = this.w <= 750 ? 'web' : 'pc'
            if (this.equipment === 'pc') {
                this.scheduleTableLayout(false)
            }
        },
        bindTableResizeObserver() {
            this.disconnectTableResizeObserver()
            if (this.layoutDisposed || !this.$refs.tableArea || typeof ResizeObserver === 'undefined') return

            this.tableResizeObserver = new ResizeObserver(() => {
                this.scheduleTableLayout(false)
            })
            this.tableResizeObserver.observe(this.$refs.tableArea)
        },
        disconnectTableResizeObserver() {
            if (this.tableResizeObserver) {
                this.tableResizeObserver.disconnect()
                this.tableResizeObserver = null
            }
        },
        scheduleTableLayout(measureContent) {
            if (this.layoutDisposed) return
            this.layoutNeedsMeasurement = this.layoutNeedsMeasurement || Boolean(measureContent)
            if (this.layoutFrame !== null) return

            this.layoutFrame = requestAnimationFrame(() => {
                this.layoutFrame = null
                if (this.layoutDisposed || this.equipment !== 'pc' || !this.$refs.tableArea) return

                if (this.layoutNeedsMeasurement || !this.columnMetrics.length) {
                    this.columnMetrics = measureColumns(this.columns, this.tableData, this.measurementOptions())
                    this.layoutNeedsMeasurement = false
                }

                const availableWidth = Math.max(0, this.$refs.tableArea.getBoundingClientRect().width - 1)
                const layout = allocateColumnWidths(this.columnMetrics, availableWidth)
                this.columnWidths = layout.columnWidths
                this.tableWidth = layout.tableWidth
            })
        },
        scheduleDataLayout() {
            this.$nextTick(() => this.scheduleTableLayout(true))
        },
        measurementOptions() {
            const table = this.$refs.resourceTable
            if (!table) return {}

            const header = window.getComputedStyle(table.querySelector('th') || table)
            const body = window.getComputedStyle(table.querySelector('td') || table)
            const font = style => `${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`
            const padding = style => ['paddingLeft', 'paddingRight', 'borderLeftWidth', 'borderRightWidth']
                .reduce((total, property) => total + (parseFloat(style[property]) || 0), 0)
            return {
                bodyFont: font(body),
                headerFont: font(header),
                cellPadding: Math.max(padding(header), padding(body)) + 1,
            }
        },
        columnStyle(index) {
            const width = this.columnWidths[index]
            return width ? { width: `${width}px` } : {}
        },
        initTableData(data) {
            const source = isRecord(data) ? data : {}
            this.columnMetrics = []
            this.columnWidths = []
            this.tableWidth = 0
            this.columns = parseArray(source.columns)
                .filter(column => isRecord(column) && column.key != null)
                .map(column => ({
                    key: asText(column.key),
                    title: asText(column.title),
                    type: column.type === 'link' ? 'link' : 'text',
                }))

            this.tableData = parseArray(source.rows).filter(isRecord).map(row => {
                const newRow = Object.create(null)
                this.columns.forEach(column => {
                    const value = Object.prototype.hasOwnProperty.call(row, column.key) ? row[column.key] : ''
                    if (column.type === 'link') {
                        newRow[column.key] = parseArray(value)
                            .filter(item => item != null && !Array.isArray(item))
                            .map(item => ({
                                key: isRecord(item) ? asText(item.key) : '',
                                value: asText(isRecord(item) ? item.value : item),
                            }))
                    } else {
                        newRow[column.key] = asText(value)
                            .split(/\r\n?|\n/)
                            .filter(item => item.trim() !== '')
                            .map(item => ({ key: '', value: item.trim() }))
                    }
                })
                return newRow
            })
            this.scheduleDataLayout()
        },
        formatUrl(url) {
            let result = asText(url).trim()
            if (!result) return ''

            // 处理 Markdown 链接
            const match = result.match(
                /^\[.*?\]\((.*?)\)$/
            )

            if (match) {
                result = match[1].trim()
            }

            // 去除反斜杠
            result = result.replace(/\\/g, '')
            if (!result) return ''

            // 自动补充协议
            if (!/^https?:\/\//i.test(result)) {
                result = 'https://' + result
            }

            return result
        },
        async getDetail() {
            if (this.layoutDisposed) return
            const requestId = ++this.detailRequestId
            this.title = ''
            this.remark = ''
            this.initTableData({})
            if (!this.infoId) return

            try {
                const res = await this.axios(
                    `/v1/api/corepower_infos_resource?infoId=${encodeURIComponent(this.infoId)}`
                )
                if (this.layoutDisposed || requestId !== this.detailRequestId) return

                if (res && res.code == '00') {
                    const detail = Array.isArray(res.data) && isRecord(res.data[0]) ? res.data[0] : {}
                    this.initTableData(detail)
                    this.title = asText(detail.title)
                    this.remark = asText(detail.remark)
                } else {
                    this.$message.error('数据请求失败')
                }
            } catch (e) {
                if (!this.layoutDisposed && requestId === this.detailRequestId) {
                    this.$message.error('数据请求失败')
                }
            }
        },

    },
};
</script>

<style lang="less" scoped>
.download {
    background: #ededed;

    // height: 2000px;
    .pc {
        position: relative;

        .top_img {
            width: 10.75rem
                /* 1075/100 */
            ;
            height: 7.63rem
                /* 763/100 */
            ;
            position: absolute;
            top: 0;
            right: 0;
        }

        main {
            position: relative;
            padding-top: 3.46rem
                /* 346/100 */
            ;
            padding-left: 1.34rem
                /* 134/100 */
            ;
            min-height: 300px;

            .naviga {
                display: flex;
                margin-bottom: 0.28rem
                    /* 49/100 */
                ;

                li {
                    font-size: 0.4rem
                        /* 40/100 */
                    ;
                    font-family: Alibaba PuHuiTi;
                    font-weight: bold;
                    color: #000000;
                    margin-right: 0.76rem
                        /* 76/100 */
                    ;
                    cursor: context-menu;
                    height: 0.7rem
                        /* 60/100 */
                    ;
                    position: relative;

                    .active {
                        width: 0.38rem
                            /* 38/100 */
                        ;
                        height: 3px;
                        background: #2569F6;
                        position: absolute;
                        left: 50%;
                        bottom: 0;
                        transform: translate(-50%);
                    }
                }
            }

            .remark {
                width: 12.35rem;

                p {
                    font-size: .22rem;
                    line-height: .30rem;
                    text-align: justifyLeft;
                    color: #000000;
                    font-family: MicrosoftYaHei;
                    margin-bottom: .29rem;
                }
            }

            .resource-table-area {
                width: calc(100vw - 2.68rem);
                max-width: calc(100vw - 2.68rem);
                position: relative;
                z-index: 1;
            }

            .resource-table {
                border-collapse: collapse;
                table-layout: fixed;
                color: #505050;
                background: #ffffff;
                font-family: "Microsoft YaHei", sans-serif;
                font-size: 14px;
                line-height: 23px;
                margin-bottom: 0.88rem;

                th,
                td {
                    border: 1px solid #c2c7d4;
                    padding: 12px;
                    text-align: left;
                    vertical-align: middle;
                    cursor: context-menu;
                }

                th {
                    background: #e7e8e8;
                    color: #909399;
                    font-weight: 600;
                    text-align: center;
                }

                .cell-content {
                    min-width: 0;
                    white-space: normal;
                    word-break: normal;
                    overflow-wrap: anywhere;
                }

                .link-call a {
                    color: #2569F6;
                    word-break: normal;
                    overflow-wrap: anywhere;
                }

                .link-call:hover {
                    text-decoration: underline;
                    cursor: pointer;
                    text-decoration-color: #2569F6;
                }

                .text-call:hover {
                    color: #2569F6;
                }
            }

            .foter_nav {
                position: absolute;
                bottom: 0
                    /* 88/100 */
                ;
                right: 0.82rem
                    /* 82/100 */
                ;

                li {
                    text-align: right;
                    font-size: 0.18rem
                        /* 18/100 */
                    ;
                    font-family: Alibaba PuHuiTi;
                    font-weight: 600;
                    color: #000000;
                    line-height: 40px;
                    cursor: pointer;

                    p {
                        font-size: 0.18rem
                            /* 18/100 */
                        ;
                        font-family: Alibaba PuHuiTi;
                        font-weight: 400;
                        color: #505050;
                        line-height: 40px;
                    }

                    .active_color {
                        color: #01b2db;
                    }
                }
            }
        }
    }

    .web {
        background: #ededed;
        position: relative;

        .top_box {
            height: 50px;
        }

        main {
            padding-left: 24px;
            padding-right: 24px;

            .web-title {
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 16px;
                color: #000000;
                text-align: justifyLeft;
                font-style: normal;
                text-transform: none;
                overflow-wrap: anywhere;
            }

            .heng {
                width: 17px;
                height: 2px;
                background: #2569F6;
                margin-top: 15px;
            }

            .Introduction {
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #000000;
                text-align: justifyLeft;
                font-style: normal;
                text-transform: none;
                margin-top: 15px;
            }

            .table-web {
                margin-top: 21px;

                ul {
                    margin-bottom: 20px;
                    border: 1px solid #BEC4D2;
                    border-bottom: none;

                    li {
                        display: flex;
                        align-items: stretch;
                        border-bottom: 1px solid #BEC4D2;
                        min-height: 35px;

                        .label-text {
                            font-size: 13px;
                            color: #383838;
                            flex: 0 0 100px;
                            width: 100px;
                            min-width: 0;
                            display: flex;
                            align-items: flex-start;
                            background: #E7E8E8;
                            padding-left: 20px;
                            padding-right: 10px;
                            box-sizing: border-box;
                            padding-top: 9px;
                            word-break: normal;
                            overflow-wrap: anywhere;
                        }

                        .label-value {
                            font-size: 12px;
                            color: #383838;
                            flex: 1;
                            min-width: 0;
                            white-space: normal;
                            word-break: normal;
                            overflow-wrap: anywhere;
                            padding: 9px 10px;
                            box-sizing: border-box;
                            padding-left: 19px;
                        }

                        .label-links {
                            flex: 1;
                            min-width: 0;
                            padding: 9px 10px;
                        }

                        .label-link {
                            display: block;
                            font-size: 12px;
                            color: #2569F6;
                            white-space: normal;
                            word-break: normal;
                            overflow-wrap: anywhere;
                            box-sizing: border-box;
                            padding-left: 10px;
                        }
                    }
                }
            }
        }


        .foot {
            background: #000;
        }
    }
}
</style>
